const websiteVersion = process.env.NODE_ENV === 'development' ? '' : 'debc686'

export default websiteVersion
